<template>
	<div>
		<div class="match-tennis">
			<div class="match-tennis_time" v-if="isInprogress" v-text="event.status_desc"></div>
			
			<div class="match-tennis_date" v-else v-text="statusText"></div>
			
			<div class="match-tennis_content">
				<div class="match_tennis_command" :class="boldClass(event.home_score, event.away_score)">
					<img :src="$hostname + event.home_image_ref" alt="">
					<span v-text="event.home_name"></span>
				</div>
				<div class="match_tennis_command" :class="boldClass(event.away_score, event.home_score)">
					<img :src="$hostname + event.away_image_ref" alt="">
					<span v-text="event.away_name"></span>
				</div>
			</div>
			
			<div class="match_tennis-result" v-if="matchStarted">
				<span v-text="event.home_score"></span>
				<span v-text="event.away_score"></span>
			</div>
			<div v-for="i in 5" :key="i">
				<div class="match-tennis_set" v-if="matchStarted">
					<span v-if="set(i)" :class="boldClass(set(i).home, set(i).away)" v-text="set(i).home"></span>
					<span v-if="set(i)" :class="boldClass(set(i).away, set(i).home)" v-text="set(i).away"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	export default {
		props: ['event'],
		
		computed: {
			isInprogress() {
				return this.event.status === 'inprogress';
			},
			statusText() {
				if (this.event.status === 'finished') {
					return 'Завершен';
				} else if (this.event.status === 'cancelled') {
					return 'Отменен';
				} else if (this.event.status === 'notstarted') {
					return this.getDate(this.event.startdate)
				}
				return this.getTime(this.event.startdate);
			},
			matchStarted() {
				return this.event.status !== 'notstarted';
			}
		},
		
		methods: {
			getDate(date) {
				if (moment(date).format('DD-MM-YYYY') === moment().startOf('day').format('DD-MM-YYYY')) {
					return moment(date).format('HH:mm');
				}
				return moment(date).format('DD.MM');
			},
			getTime(date) {
				if (this.showDate) {
					return moment(date).format('DD.MM HH:mm');
				}
				return moment(date).format('HH:mm');
			},
			boldClass(team1, team2) {
				if (Number(team1) > Number(team2) && this.event.status === 'finished') {
					return ['__bold'];
				}
				return [];
			},
			set(i) {
				return this.event.results['set' + i];
			}
		}
	}
</script>

<style scoped>

</style>